export const CLOUDINARY_UPLOAD_PRESET_COMPANY_LOGO = 'company-logo-upload';
export const CLOUDINARY_UPLOAD_URL = 'https://api.cloudinary.com/v1_1/base10/image/upload';
export const CLOUDINARY_URL = 'cloudinary://924979426899781:mBH1haMdqtIuCcq8zSA1awtQZVA@base10';
export const BACKEND_URL = 'https://api.base10.vc';

export const PLACEHOLDER_IMAGE = 'https://via.placeholder.com/150';

// Shared with gatsby-node.js via CommonJS config (Node cannot require .ts directly)
// eslint-disable-next-line @typescript-eslint/no-var-requires
const { PRISMIC_BASE_URL, PRISMIC_ACCESS_TOKEN } = require('./prismic.config.js');

export { PRISMIC_BASE_URL, PRISMIC_ACCESS_TOKEN };

/**
 * Used for old wordpress users. Triggers a password reset prompt
 */
export const OLD_PASSWORD = 'old';

export const QUARTERLY_PASSWORD = 'quarterlyletter';
